module.exports = __webpack_public_path__ + "assets/img/logo.068fe257.png";